import { LocalizeCurrencyOptions, useLocalizeCurrency } from './useLocalizeCurrency';

interface LocalizedCurrencyProps {
    value: number;
    options?: LocalizeCurrencyOptions;
    currency: string;
}

export const LocalizedCurrency = ({ value, currency, options }: LocalizedCurrencyProps) => {
    const localizeCurrency = useLocalizeCurrency();
    return <>{localizeCurrency(value, currency, options)}</>;
};
